// extracted by mini-css-extract-plugin
module.exports = {"Wrapper":"LoadingProgressBar_Wrapper__EDL83","Bar":"LoadingProgressBar_Bar__2CzdV"};